module.exports = __webpack_public_path__ + "img/start_7.f6120655.svg";